import TopAdvice from './styled';

export default TopAdvice;
